module.exports = __webpack_public_path__ + "static/img/icon_group_2.af0b1c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/icon_group_2.png
// module id = dVdo
// module chunks = 0